export default {
  'call-dispatcher': 'Call the dispatcher',
  'error-code': 'Error {code}',
  'dispatcher-hint': 'Please contact Rx2Go <br /> dispatcher if you see this error',
  400: {
    title: 'Bad Request',
    description: 'It looks like the link you clicked might have a small issue, so we couldn\'t process your request.',
  },
  404: {
    title: 'Not Found',
    description: 'The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.',
  },
  500: {
    title: 'Internal Server Error',
    description: 'We encountered an unexpected error. Please try again later.',
  },
  generic: {
    title: 'Something went wrong',
    description: 'Something went wrong',
  },
}
